import { render, staticRenderFns } from "./DuplicateShopCategoryForm.vue?vue&type=template&id=24baf2f3&scoped=true"
import script from "./DuplicateShopCategoryForm.vue?vue&type=script&lang=js"
export * from "./DuplicateShopCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./DuplicateShopCategoryForm.vue?vue&type=style&index=0&id=24baf2f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24baf2f3",
  null
  
)

export default component.exports